var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ns-button',{on:{"click":_vm.onPayment}},[_vm._v("결제")])}
var staticRenderFns = []

export { render, staticRenderFns }